import './AlarmPanel.scss';

export { default as AlarmPanel } from './AlarmPanel';
export { getAlarmPanelSchema } from './alarmPanelSchema';
